export const timeFormat = {
  longWithTime: 'MMM d, yy HH:mm',
  long: 'MMM d, yy',
  shortWithTime: 'MMM d, HH:mm',
  short: 'MMM d',
  time: 'HH:mm',
  timeLong: 'HH:mm:ss',
  timeWithMs: 'mm:ss SSS',
  dayMonth: 'dd/MM',
  monthYear: 'MMM, yy',
  longDateTime: 'MMM d, yy HH:mm:ss',
};
